import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
// title animation
const textWrapper = document.querySelector('.contact__header .letters')
textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter inline-block'>$&</span>")

gsap.from('.contact__header .letter', {
  scrollTrigger: '.contact__header',
  duration: 1.5,
  delay: 0.3,
  scale: 0,
  y: 50,
  x: -50,
  stagger: {
    amount: 0.1
  },
  ease: 'Elastic.easeOut'
})
